import React from "react";
import { FaFacebook, FaInstagram, FaEnvelope, FaPhone, FaMapMarkerAlt } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const Footer = () => {
	const { t } = useTranslation();

	const socialLinks = [
		{
			icon: FaInstagram,
			href: "https://www.instagram.com/kostas_premtis/",
			label: "Instagram",
			hoverColor: "hover:bg-gradient-to-br hover:from-purple-500 hover:to-pink-500",
		},
		{
			icon: FaFacebook,
			href: "https://www.facebook.com/kwstas.okirilatos",
			label: "Facebook",
			hoverColor: "hover:bg-blue-600",
		},
		{
			icon: FaEnvelope,
			href: "mailto:premtisk@gmail.com",
			label: "Email",
			hoverColor: "hover:bg-accent",
		},
	];

	const contactInfo = [
		{ icon: FaPhone, text: "22410 43755" },
		{ icon: FaEnvelope, text: "premtisk@gmail.com" },
		{ icon: FaMapMarkerAlt, text: `${t("street")} 49, ${t("city")}, 85132` },
	];

	return (
		<footer className="bg-gradient-to-b from-slate-800 to-slate-900 text-white relative overflow-hidden">
			{/* Top accent line */}
			<div className="h-1 bg-gradient-to-r from-slate-600 via-accent to-slate-600"></div>

			{/* Background decoration */}
			<div className="absolute top-0 left-1/4 w-96 h-96 bg-accent/5 rounded-full blur-3xl"></div>
			<div className="absolute bottom-0 right-1/4 w-96 h-96 bg-slate-500/5 rounded-full blur-3xl"></div>

			<div className="container mx-auto px-6 py-12 relative z-10">
				<div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
					{/* Brand Section */}
					<div className="text-center md:text-left">
						<h2 className="text-2xl font-bold mb-3">
							<span className="gradient-text">{t("footer.business")}</span>
						</h2>
						<p className="text-gray-400 text-sm leading-relaxed">
							{t("footer.businessDescription")}
						</p>
					</div>

					{/* Contact Info */}
					<div className="text-center md:text-left">
						<h3 className="text-lg font-semibold mb-4 text-white">
							{t("navbar.contact")}
						</h3>
						<ul className="space-y-3">
							{contactInfo.map((item, index) => (
								<li
									key={index}
									className="flex items-center gap-3 text-gray-400 text-sm justify-center md:justify-start"
								>
									<item.icon className="text-accent flex-shrink-0" />
									<span>{item.text}</span>
								</li>
							))}
						</ul>
					</div>

					{/* Social Links */}
					<div className="text-center md:text-right">
						<h3 className="text-lg font-semibold mb-4 text-white">
							Social Media
						</h3>
						<div className="flex gap-3 justify-center md:justify-end">
							{socialLinks.map((social, index) => (
								<a
									key={index}
									href={social.href}
									target="_blank"
									rel="noopener noreferrer"
									aria-label={social.label}
									className={`w-11 h-11 rounded-xl bg-gray-800 flex items-center justify-center text-gray-400 transition-all duration-300 hover:text-white hover:scale-110 hover:shadow-lg ${social.hoverColor}`}
								>
									<social.icon className="text-lg" />
								</a>
							))}
						</div>
					</div>
				</div>

				{/* Bottom Section */}
				<div className="mt-10 pt-8 border-t border-gray-800">
					<p className="text-center text-gray-500 text-sm">
						&copy; {new Date().getFullYear()} {t("footer.business")}. All rights reserved.
					</p>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
